/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type ValidatePayoutRequestDestinationOneOfFourRelationship = typeof ValidatePayoutRequestDestinationOneOfFourRelationship[keyof typeof ValidatePayoutRequestDestinationOneOfFourRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidatePayoutRequestDestinationOneOfFourRelationship = {
  Parents: 'Parents',
  Siblings: 'Siblings',
  Other_Relatives: 'Other Relatives',
  Vendor: 'Vendor',
  Supplier: 'Supplier',
  Employee: 'Employee',
  Spouse: 'Spouse',
  Friends: 'Friends',
  Employer: 'Employer',
  Child: 'Child',
  Self: 'Self',
  Business_Partner: 'Business Partner',
  Agent: 'Agent',
  Creditor: 'Creditor',
  Others: 'Others',
} as const;
